import { localStorage, sessionStorage } from '../utils/storage'
import useBrowserMode from '../hooks/useBrowserMode'

const { isBrowser } = useBrowserMode()
const STORAGE_KEYS = {
	USER_DATA: 'USER_INFO',
	TOKEN_DATA: 'TOKEN_INFO',
	USER_IDENTIFIER: 'userName'
}

const findStorage = key => {
	return isBrowser && (localStorage.getItem(key) || sessionStorage.getItem(key))
}

const getUserData = () => {
	return findStorage(STORAGE_KEYS.USER_DATA)
}

const getTokenData = () => {
	return findStorage(STORAGE_KEYS.TOKEN_DATA)
}

const getIdTokenData = () => {
	const token = getTokenData()
	return token && token.idToken
}

const getRefreshTokenData = () => {
	const token = getTokenData()
	return token && token.refreshToken
}

const getUserName = () => {
	return findStorage(STORAGE_KEYS.USER_IDENTIFIER)
}

const getUserPoints = () => {
	const data = getUserData()
	return data && data.points
}

const destroySession = () => {
	if (isBrowser) {
		localStorage.removeItem(STORAGE_KEYS.USER_DATA)
		localStorage.removeItem(STORAGE_KEYS.TOKEN_DATA)
		localStorage.removeItem(STORAGE_KEYS.USER_IDENTIFIER)
	}
}

const SessionService = {
	getUserData,
	getTokenData,
	getIdTokenData,
	getRefreshTokenData,
	getUserPoints,
	getUserName,
	destroySession,
}

export default SessionService